import { ICON_COLOR } from '../menu';

export default function Today({ color = ICON_COLOR, size = 20 }) {
  return (
    <svg width={size} height={size} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.8333 2.49992H15V1.66659C15 1.20825 14.625 0.833252 14.1667 0.833252C13.7083 0.833252 13.3333 1.20825 13.3333 1.66659V2.49992H6.66667V1.66659C6.66667 1.20825 6.29167 0.833252 5.83333 0.833252C5.375 0.833252 5 1.20825 5 1.66659V2.49992H4.16667C3.24167 2.49992 2.50833 3.24992 2.50833 4.16659L2.5 15.8333C2.5 16.7499 3.24167 17.4999 4.16667 17.4999H15.8333C16.75 17.4999 17.5 16.7499 17.5 15.8333V4.16659C17.5 3.24992 16.75 2.49992 15.8333 2.49992ZM15 15.8333H5C4.54167 15.8333 4.16667 15.4583 4.16667 14.9999V6.66658H15.8333V14.9999C15.8333 15.4583 15.4583 15.8333 15 15.8333ZM6.66667 8.33325H9.16667C9.625 8.33325 10 8.70825 10 9.16658V11.6666C10 12.1249 9.625 12.4999 9.16667 12.4999H6.66667C6.20833 12.4999 5.83333 12.1249 5.83333 11.6666V9.16658C5.83333 8.70825 6.20833 8.33325 6.66667 8.33325Z'
        fill={color}
      />
    </svg>
  );
}
